export default __webpack_public_path__ + "static/logo-full-white-93df45d038d6e30dd8252f5a73dbd657.png";